import { httpsCallable } from 'firebase/functions'
import store from '../store'
import { firebaseFunctions } from '@web/firebase.js'
import { fetchProjects } from '@web/api/project-api.js'

const FORM_STATES = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

const initialState = {
  formState: FORM_STATES.IDLE,
  interest: null,
  projects: [],
}

store.registerModule('REFERRAL', {
  namespaced: true,
  state: initialState,
  actions: {
    SUBMIT_REFERRAL(ctx, payload) {
      ctx.commit('SET_FORM_STATE', FORM_STATES.PENDING)
      const project = payload.candidate.project ? ctx.state.projects.find(p => p.id === payload.candidate.project) : undefined
      const data = {
        ...payload.contact,
        project: project || {},
        candidate: {
          ...payload.candidate,
        },
        type: 'referral-interest',
      }

      const firebaseProcessExtra = httpsCallable(firebaseFunctions, 'processFormReferral')
      firebaseProcessExtra(data)
        .then(() => void ctx.commit('SET_FORM_STATE', FORM_STATES.SUCCESS))
        .catch(() => void ctx.commit('SET_FORM_STATE', FORM_STATES.ERROR))
    },
    async LOAD_PROJECTS({ commit }) {
      const response = await fetchProjects()

      commit('SET_PROJECTS', response.page.content)
    },
    // async LOAD_INTEREST(ctx, candidateId) {
    //     const query = firestore().doc(`interests/${candidateId}`);
    //     const { document } = await getDocument(query);
    //     ctx.commit("SET_INTEREST", document);
    // },
    async REMOVE_CANDIDATE(ctx, candidateId) {
      await httpsCallable(firebaseFunctions, 'processFormReferralRemoveCandidate')(candidateId)
    },
  },
  mutations: {
    SET_FORM_STATE(state, formState) {
      state.formState = formState
    },
    SET_PROJECTS(state, projects) {
      state.projects = projects
    },
    SET_INTEREST(state, interest) {
      state.interest = interest
    },
  },
})
